import { combineReducers } from 'redux';

import dictionariesReducer from './dictionaries/store/reducer';
import policiesReducer from './policies/store/reducer';
import paymentsReducer from './payments/store/reducer';
import promoCodesReducer from './promocodes/store/reducer';

export default combineReducers({
  dictionaries: dictionariesReducer,
  policies: policiesReducer,
  payments: paymentsReducer,
  promocodes: promoCodesReducer,
});
